import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "drivr-unauth-layout" }
const _hoisted_2 = { class: "drivr-unauth-layout__wrap" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "drivr-unauth-layout__logo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "DRIVR")
], -1)
const _hoisted_4 = { class: "drivr-unauth-layout__content" }
const _hoisted_5 = { class: "drivr-unauth-layout__footer" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://drivr.cloud/saas-privacy-policy/",
    class: "drivr-unauth-layout__footer-link"
  }, "Privacy Policy")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://drivr.cloud/imprint/",
    class: "drivr-unauth-layout__footer-link"
  }, "Imprint")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_unauth_bg = _resolveComponent("ui-unauth-bg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_unauth_bg),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("li", null, _toDisplayString(_ctx.footer), 1),
        _hoisted_6,
        _hoisted_7
      ])
    ])
  ]))
}